import React, { Component } from 'react'
import { connect } from 'react-redux'
import FocusLock from 'react-focus-lock'
import {
  notebookSection,
  notebookPopout,
  setTotalProtocolPages,
  toggleNotebookExpanded
} from '../../actions';
import NotebookSection from './notebookSection/NotebookSection'
import ProtocolView from './protocolView/ProtocolView'
import './Notebook.scss'

import NotebookIcon from './img/notebook-icon.svg'
import NotebookIconHover from './img/notebook-icon-hover.svg'
import NotebookIconCollapse from './img/notebook-icon-collapse.svg'

import { withTranslation } from 'react-i18next'
import {LogEvent} from '@learningblocks/shared-components/lib/EventLogger';
import {UsersnapContext} from "@labxchange/util-usersnap";
import IFrameFocusManager from '@learningblocks/shared-components/lib/IFrameFocusManager';

const sections = [
  "Context",
  "Materials",
  "Predictions",
  "Protocol",
  "Results",
  "Reflection",
  "Summary",
]

//This component coordinates all the Notebook logic and data flow
class Notebook extends Component {

  constructor(props) {
    super(props);

    this.state = {
      notebookIconHover: false
    }
  }
  static contextType = UsersnapContext;
  
  onSectionSelect = (section) => {
    if (section.section !== "Protocol") {

      if (section.section === this.props.sectionSelected) {
        this.props.notebookPopout(!this.props.sliderOpen)
      } else {

        if (this.props.sectionSelected === false || this.props.sectionSelected === null) {
          this.props.notebookPopout(!this.props.sliderOpen)
        }
      }
    } else if (section.section === "Protocol") {

      //Setting total pages in prep for rendering Protocol View
      if (this.props.taskPages.length > 0) {
        this.props.setTotalProtocolPages(this.props.taskPages.length)
      }

      this.props.notebookPopout(false)
    }
    // Open the collapse
    this.props.notebookSection(section);

    // If the section is the currently open section
    if (section.section === this.props.sectionSelected) {
      // Close the collapse
      this.props.notebookSection({ section: false });
    }
  }

  //Render list first - then protocol if clicked
  renderSectionList = () => {
    return sections.map((text, index) => (
      <NotebookSection
        text={text}
        onSelect={this.onSectionSelect}
        focused={text === this.props.sectionSelected}
        key={text}
        index={index + 1} />
    ))
  }

  renderProtocolView = () => {
    return (
      <ProtocolView
        key={1}
        tasks={this.props.taskPages}
        index={3} />
    )
  }


  openSlider = () => {
    this.props.notebookPopout(!this.props.sliderOpen)
  }

  toggleExpanded = () => {
    this.props.toggleNotebookExpanded()
  }

  render() {
    return (
      <div tabIndex={-1} id='notebook'
         className={((this.props.sliderOpen) ? 'open' : 'closed') + ' ' + ((this.props.notebookExpanded) ? 'expanded' : '')}>
        <div id='notebook-head'>
          <LogEvent
            logEventProps={{
              event_type: (this.props.notebookExpanded)?"sim_sidebar_minimize_btn clicked":"sim_sidebar_maximize_btn clicked",
              event_schema: "track",
              collapsed: this.props.collapsed
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
          <img
            src={(this.props.notebookExpanded) ? (this.state.notebookIconHover) ? NotebookIconHover : NotebookIcon : NotebookIconCollapse}
            className="notebook-icon"
            onClick={(e) => { this.toggleExpanded(e) }}
            onMouseEnter={() => {
              this.setState({
                notebookIconHover: true
              })
            }}
            alt={this.props.t("Notebook display button. Select to show or hide the notebook.")}
            onMouseOut={() => {
              this.setState({
                notebookIconHover: false
              })
            }} 
          />
          </LogEvent>
          <h2 tabIndex={-1} aria-label={this.props.t("Lab notebook section heading.")} id='notebook-title'>
            {this.props.t("LAB NOTEBOOK")}
          </h2>
          <h3 id='notebook-sub-title'>
            {this.props.t("Micropipetting Solutions")}
          </h3>
        </div>
        <div 
            tabIndex={-1}
            className={'notebook-body ' + this.props.sectionSelected}
            style={{ display: (this.props.notebookExpanded) ? null : "none" }}>
              <FocusLock disabled={this.props.sectionSelected === 'Protocol' || this.props.modalVisible || this.context.isActive }>
                <IFrameFocusManager>
                  {(this.props.sectionSelected === "Protocol") ? this.renderProtocolView() : this.renderSectionList()}
                </IFrameFocusManager>
              </FocusLock>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sectionSelected: state.notebook.sectionSelected,
    sliderOpen: state.notebook.sliderOpen,
    taskPages: state.notebook.taskPages,
    modalVisible: state.modal.display,
    notebookExpanded: state.scene.notebookExpanded,
  }
}

export default connect(mapStateToProps, {
  notebookSection,
  notebookPopout,
  setTotalProtocolPages,
  toggleNotebookExpanded
})(withTranslation()(Notebook));
